import React from 'react';
import {
	Box,
	Button,
	FormLabel,
	InputGroup,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Select,
	useDisclosure,
} from '@chakra-ui/react';
import defaultPages from '../../utils/defaultPages';
import { useDispatch, useSelector } from 'react-redux';
import { allPages, updatePages } from '../../redux/pagesSlice';

// function setTemplates(pages, templateId) {
//     pages.forEach(({ pageData }, index) => {
//         pageData.forEach((_, pageDataIndex) => {
//             if (!pages[index].pageData[pageDataIndex].templateId) pages[index].pageData[pageDataIndex].templateId = templateId;
//         });
//     });
// }

const ResetPageBlocksButton = () => {
	const { isOpen, onOpen, onClose } = useDisclosure();
	const dispatch = useDispatch();
	const pages = useSelector(allPages);
	const [selectedOption, setSelectedOption] = React.useState('');
	const [pagesToList, setPagesToList] = React.useState([]);

	React.useEffect(() => {
		const templateId = 1;
		const defaultPagesObject = defaultPages(templateId);
		setPagesToList(defaultPagesObject);
	}, []);

	const handleClick = (e) => {
		const newPages = JSON.parse(JSON.stringify(pages));
		const page = newPages.find((page) => page.pageId == selectedOption);
		const defaultPage = pagesToList.find((defaultPage) => defaultPage.pageId == selectedOption);
		if (!page) {
			newPages.push(defaultPage);
		} else {
			page.pageData = defaultPage.pageData;
		}
		dispatch(updatePages(newPages));
		onClose();
	};

	const handleChange = (e) => {
		if (!e.target.value) return;
		setSelectedOption(e.target.value);
		onOpen();
	};

	return (
		<>
			<Box>
				<InputGroup display={'flex'} flexDir={'column'} pos={'inherit'}>
					<FormLabel top={0} fontSize={'xs'} m={0}>
						Reset Page
					</FormLabel>
					<Select defaultValue={selectedOption} size="xs" onChange={handleChange}>
						<option value={''}>Escolha a página</option>
						{pagesToList.map(({ pageId, pageType, pageName }, index) => (
							<option key={`${pageId}-${pageType}-${index}`} value={pageId}>
								{pageName}
							</option>
						))}
					</Select>
				</InputGroup>
			</Box>
			<Modal isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Resetar página</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						Você tem certeza que quer resetar a página selecionada para o estado inicial? Esse processo é irreversível,
						você perderá todas as alterações feitas na página
					</ModalBody>

					<ModalFooter>
						<Button variant="ghost" onClick={onClose}>
							Cancelar
						</Button>
						<Button colorScheme="blue" mr={3} onClick={handleClick}>
							Resetar página
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	);
};

export default ResetPageBlocksButton;
